import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

export default function Spinner(props) {
  return <CircularProgress size={props.size} sx={{ color: props.color }} />;
}
